import React from 'react';
import Header from './components/header';
import './index.css';
import './tehnologies.css';
import flutter from './assets/tech-flutter.svg';
import react from './assets/tech-react.svg';
import android from './assets/tech-android.svg';
import angular from './assets/tech-angular.svg';
import flask from './assets/tech-flask.svg';
import aws from './assets/aws-white.svg'
import supabase from './assets/supabase.svg';
import BannerSection from './components/banner';
import Footer from './components/footer';
import PageTitle from "./components/page-title";

class Technology extends React.Component {
    render() {
        return (
            <div className='flex-row flex-vertical-center tool-technology'>
                <div className='technology-left'>
                    <img className="tool-technology-img" alt="web development logo" src={this.props.technology.image} />
                </div>

                <div className='tools-technology-separator mr-5' />

                <div className='technology-right white-color-txt'>
                    <div className="tool-technology-name t5 mb-2" >{this.props.technology.name}</div>
                    <div className='b2'>{this.props.technology.desc}</div>
                </div>
            </div>
        )
    }
}

class ToolsAndTehnologies extends React.Component {

    render() {

        const technologies = [
            {
                name: "FLUTTER",
                image: flutter,
                desc: "Flutter is our go-to for stunning, natively compiled applications from a single codebase. We leverage Flutter to deliver fast, fluid, and visually rich experiences that engage your users, ensuring your app looks and performs great everywhere.",
            },
            { 
                name: "REACT",
                image: react,
                desc: "React makes it easy to create interactive UIs. Build encapsulated components that manage their own state, then compose them to make complex UIs. React can also render on the server using Node and power mobile apps using React Native."
            },
            { 
                name: "ANDROID",
                image: android,
                desc: "We specialize in native Android development, crafting robust, feature-rich, and highly optimized apps designed specifically for the Android ecosystem. We ensure your application delivers a seamless, intuitive, and secure experience for millions of users."
            },
            { 
                name: "AWS CLOUD SERVICES",
                image: aws,
                desc: "We leverage Amazon Web Services (AWS) to build and deploy robust, high-performance, and cost-effective cloud solutions. We utilize AWS's comprehensive suite of serverless architectures, managed databases to ensure your digital products are reliable, agile, and ready to grow."
            },
            { 
                name: "SUPABASE",
                image: supabase,
                desc: "We leverage Supabase to provide a robust, scalable, and feature-rich foundation for your project. With its integrated PostgreSQL database, authentication, real-time subscriptions, and storage, we deliver fast development cycles and flexible solutions that truly own your data."
            },
            { 
                name: "ANGULAR",
                image: angular,
                desc: "Angular development is aimed at building large-scale dynamic applications. Created by Google, Angular is an open-source JavaScript framework offering a rich toolset that helps write less code, make it well-structured, easy to test, reuse and maintain "
            },
            { 
                name: "FLASK",
                image: flask,
                desc: "Flask is a lightweight WSGI web application framework. It is designed to make getting started quick and easy, with the ability to scale up to complex applications. It began as a simple wrapper around Werkzeug and Jinja and has become one of the most popular Python web application frameworks"
            },
        ];


        return (
            <div className="technologies flex-column-centered section pb-5" > 

                <div className='white-band' />

                <div className='flex-column-centered technologies-column'>
                    {/* <div className='technologies-column-inner'>
                    </div> */}

                    { technologies.map( (tech, index) => <Technology key={index} technology={tech} />)}
                </div>
            </div>
        );
    }
}

class Technologies extends React.Component {
    
    componentDidMount() {
        window.scrollTo(0, 0);

        const head = document.head;
        const url = `https://www.binaryfusion.ro/technologies`;

        // Check if a canonical link already exists
        let link = document.querySelector("link[rel='canonical']");

        if (link) {
            // Update existing link
            link.setAttribute("href", url);
        } else {
            // Create a new link element
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            link.setAttribute("href", url);
            head.appendChild(link);
        }
    }
    
    render() {
        return (
            <div id="all-sections" className='section-background-2'>
                <Header className='with-bottom-border-1' />

                <PageTitle title={'Technologies'}
                           subtitle={'Turn your next business app idea into action. Tailor-made software development services for startups and small-sized companies. Accelerate new ideas and obtain real business value by getting the most out of our production-ready custom software development services.'}
                />
                
                <ToolsAndTehnologies />

                <BannerSection />
                
                <Footer />
            </div>
        );
    }
}

export default Technologies;